<script>

import config from "@/helpers/config"
import List from '@/components/List/List.vue'
export default {
    components: {List},
    created() {
        this.$cache.createCache('userOwnerCourses', 'user-owner-courses/') 
    },
    data() {
        return {          
          columns: [             
                { name: 'full_name', displayName: 'Namn', width: 240, hideFilter: false},
                { name: 'email', displayName: 'Email adress', width: 240, hideFilter: false},
                { name: 'mobile_no', displayName: 'Mobilnummer', width: 240, hideFilter: false},
                { name: 'comments', displayName: 'Kommentar', width: 800, hideFilter: false},
            ]
        }
    },
    methods: {
        goTopage(courseItem)
        {       
            this.$router.push({ name: 'ownerCoursesDetails', params: { id: courseItem.id } })
        }  
    },
    computed: {
        userOwnerCourses() {  return this.$store.state.userOwnerCourses == null ? [] : this.$store.state.userOwnerCourses; },
        openApplications() {  return this.$store.state.adminOpenApplication == null ? [] : this.$store.state.adminOpenApplication; },
        url() { return config.urlToServer },
        customer() { return this.$store.state.customer; }    
    }
}
</script>
<template>
    <div v-fade-in>
        <main class="opacity-white-bg">
        <section>
            <h2>{{this.$store.state.settings.OpenApplication.plural}}</h2>               
        </section>
        <div class="OpenApplication-wrapper">
                    <div v-for="openApplication in openApplications" class="OpenApplication-booking-item"> 
                        <div @mouseover="openApplication.hovered = true" @mouseout="openApplication.hovered = false">
                            <div class="position-relative g-30">
                                <div class="OpenApplication-img-area">
                                    <img v-if="openApplication.image_id" :src="url + 'uploads/'+ customer.id+'/images/thumbnails/'+ openApplication.image_name" />  
                                    <i v-else class="fa-regular fa-image wow-color wow-color-bg"></i>
                                </div>
                                <h4 class="wow-color">{{ openApplication.title }}</h4>
                            </div> 
                            <div class="g-70">
                                <div v-if="openApplication.applicants.length > 0" style="margin-left: 15px">
                                    <h2 style="margin-top: 0px;">Lista av anmält intresse</h2>
                                    <List :items="openApplication.applicants" :height="260" :columns="columns" :nameOfItems="'anmälningar'" :noOfFrozenColumns="this.$isMobile ? 1 : 1" :hideExcelExport="true"></List>
                                </div>
                                <div v-else  style="margin-left: 15px">Än så länge har ingen anmält intresse.</div>
                            </div>                          
                        </div>              
                    </div>
                </div>
        </main>
    </div>
</template>
<style scoped>

.OpenApplication-wrapper
    {
        display:flex;
        flex-wrap: wrap;
        padding: 10px 10px 0px 10px;
    }

    .OpenApplication-booking-item
    {
        padding:10px; 
        margin: 20px;
        width: calc(100% - 60px);
        background-color: white;
        border-radius: 10px;
    }
    
    .OpenApplication-img-area
    { 
        height: 240px; 
        overflow: hidden;
        text-align: center;
    }

    .OpenApplication-img-area i
    {
        display:block;
        padding-top: 40px;
        font-size: 60px;
        background-color:aliceblue;
        height: 100vh;
    }

    img
    {
        width: 100%;
    }

    h4{
        margin-bottom:0px;
        padding:10px;
        width: 50%;
        position: absolute;
        bottom: -20px;
        left: 10px;
    }

    @media only screen and (max-width: 1000px) {
        .OpenApplication-img-area {
            height: auto;
            width: auto;
        }
        
        .OpenApplication-booking-item
        {
            padding:10px; 
            margin: 30px;
            width: calc(100% - 80px);
        }   
    }
</style>